<template>
  <div class="col-12 offset-1">
    <div class="card mb-5" style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">تعديل بيانات الموضوع</h6>
          </div>
        </div>
      </div>
      <LoadingSpinner v-if="isLoading" message="جاري تحميل بيانات الموضوع..." />
      
      <template v-else-if="topic">
        <TopicForm
          ref="topicForm"
          :initial-data="{
            name: topic.name,
            chapter_id: topic.chapter_subject?.chapter_id || topic.chapter_subject?.chapter?.id,
            subject_id: topic.chapter_subject?.subject_id || topic.chapter_subject?.subject?.id,
            status: topic.status
          }"
          :subject-name="topic.chapter_subject?.subject?.name || topic.chapter_subject?.subject_name"
          :is-loading="isUpdating"
          :is-edit-mode="true"
          submit-text="حفظ التعديلات"
          @submit="updateTopic"
          @cancel="navigateBack"
          @update:form-data="handleFormUpdate"
        />
      </template>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useToast } from 'vue-toastification';
import TopicForm from "@/components/features/topics/TopicForm.vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import api from "@/api"; 

const router = useRouter();
const route = useRoute();
const toast = useToast();
const topicForm = ref(null);

const isLoading = ref(false);
const isUpdating = ref(false);
const topic = ref(null);
const originalFormData = ref(null);
const currentFormData = ref({
  name: "",
  chapter_id: null,
  subject_id: null,
  status: "active"
});

const tenantId =
  route.query.tenant_id ||
  route.params.tenant_id ||
  localStorage.getItem("tenant_id") ||
  null;

const hasChanges = computed(() => {
  if (!originalFormData.value) return false;

  return (
    currentFormData.value.name !== originalFormData.value.name ||
    String(currentFormData.value.chapter_id) !== String(originalFormData.value.chapter_id) ||
    currentFormData.value.status !== originalFormData.value.status
  );
});

watch(hasChanges, (newVal) => {
  console.log('Has changes:', newVal);
  console.log('Original:', originalFormData.value);
  console.log('Current:', currentFormData.value);
});

const handleFormUpdate = (newData) => {
  currentFormData.value = { ...newData };
};

const fetchTopic = async () => {
  isLoading.value = true;
  try {
    const response = await api.get(`/topics/${route.params.id}`, {
      params: {
        tenant_id: tenantId || undefined,
        with: 'chapterSubject.subject,chapterSubject.chapter'
      }
    });

    topic.value = response.data.data;

    originalFormData.value = {
      name: topic.value.name,
      chapter_id: topic.value.chapter_subject?.chapter_id || topic.value.chapter_subject?.chapter?.id,
      subject_id: topic.value.chapter_subject?.subject_id || topic.value.chapter_subject?.subject?.id,
      status: topic.value.status
    };

    currentFormData.value = { ...originalFormData.value };
  } catch (error) {
    toast.error("فشل في تحميل بيانات الموضوع");
    console.error("Error fetching topic:", error);
    router.back();
  } finally {
    isLoading.value = false;
  }
};

const updateTopic = async (formData) => {
  if (!hasChanges.value) {
    toast.info("لم تقم بإجراء أي تغييرات");
    return;
  }

  isUpdating.value = true;
  try {
    const csResponse = await api.get('/chapter-subjects', {
      params: {
        tenant_id: tenantId || undefined,
        chapter_id: formData.chapter_id,
        subject_id: formData.subject_id
      }
    });

    let chapterSubjectId;

    if (csResponse.data.data.length > 0) {
      chapterSubjectId = csResponse.data.data[0].id;
    } else {
      const createResponse = await api.post('/chapter-subjects', {
        tenant_id: tenantId || undefined,
        chapter_id: formData.chapter_id,
        subject_id: formData.subject_id,
        status: 'active'
      });
      chapterSubjectId = createResponse.data.data.id;
    }

    await api.put(`/topics/${route.params.id}`, {
      tenant_id: tenantId || undefined,
      name: formData.name,
      status: formData.status,
      chapter_subject_id: chapterSubjectId
    });

    toast.success("تم تحديث بيانات الموضوع بنجاح");
    router.back();
  } catch (error) {
    if (error.response?.status === 422) {
      toast.error("الرجاء تصحيح الأخطاء في النموذج");
    } else {
      toast.error(error.response?.data?.message || "فشل في تحديث البيانات");
    }
    console.error("Error updating topic:", error);
  } finally {
    isUpdating.value = false;
  }
};

const navigateBack = () => {
  router.back();
};

onMounted(() => fetchTopic());
</script>